/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { InvoiceContactInfoSnapshot } from './InvoiceContactInfoSnapshot';
import {
    InvoiceContactInfoSnapshotFromJSON,
    InvoiceContactInfoSnapshotFromJSONTyped,
    InvoiceContactInfoSnapshotToJSON,
    InvoiceContactInfoSnapshotToJSONTyped,
} from './InvoiceContactInfoSnapshot';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';
import type { InvoiceAddressSnapshot } from './InvoiceAddressSnapshot';
import {
    InvoiceAddressSnapshotFromJSON,
    InvoiceAddressSnapshotFromJSONTyped,
    InvoiceAddressSnapshotToJSON,
    InvoiceAddressSnapshotToJSONTyped,
} from './InvoiceAddressSnapshot';
import type { InvoiceStatus } from './InvoiceStatus';
import {
    InvoiceStatusFromJSON,
    InvoiceStatusFromJSONTyped,
    InvoiceStatusToJSON,
    InvoiceStatusToJSONTyped,
} from './InvoiceStatus';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';
import type { InvoiceDetailSnapshot } from './InvoiceDetailSnapshot';
import {
    InvoiceDetailSnapshotFromJSON,
    InvoiceDetailSnapshotFromJSONTyped,
    InvoiceDetailSnapshotToJSON,
    InvoiceDetailSnapshotToJSONTyped,
} from './InvoiceDetailSnapshot';

/**
 * 
 * @export
 * @interface InvoiceResponse
 */
export interface InvoiceResponse {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof InvoiceResponse
     */
    id: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof InvoiceResponse
     */
    tenantId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {Date}
     * @memberof InvoiceResponse
     */
    billingDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof InvoiceResponse
     */
    invoiceDate: Date;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof InvoiceResponse
     */
    userId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof InvoiceResponse
     */
    vaultId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResponse
     */
    userVaultType: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResponse
     */
    userName: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResponse
     */
    email: string | null;
    /**
     * 
     * @type {InvoiceAddressSnapshot}
     * @memberof InvoiceResponse
     */
    address: InvoiceAddressSnapshot | null;
    /**
     * 
     * @type {InvoiceContactInfoSnapshot}
     * @memberof InvoiceResponse
     */
    contactInfo: InvoiceContactInfoSnapshot | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof InvoiceResponse
     */
    studentId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResponse
     */
    studentName: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResponse
     */
    currency: string;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof InvoiceResponse
     */
    locationId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResponse
     */
    locationName: string | null;
    /**
     * 
     * @type {number}
     * @memberof InvoiceResponse
     */
    totalAmount: number;
    /**
     * 
     * @type {InvoiceStatus}
     * @memberof InvoiceResponse
     */
    status: InvoiceStatus;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResponse
     */
    failureReason: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceResponse
     */
    emailed: boolean;
    /**
     * 
     * @type {Date}
     * @memberof InvoiceResponse
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof InvoiceResponse
     */
    releasedAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof InvoiceResponse
     */
    processedAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof InvoiceResponse
     */
    emailedAt: Date | null;
    /**
     * 
     * @type {Array<InvoiceDetailSnapshot>}
     * @memberof InvoiceResponse
     */
    details: Array<InvoiceDetailSnapshot>;
}



/**
 * Check if a given object implements the InvoiceResponse interface.
 */
export function instanceOfInvoiceResponse(value: object): value is InvoiceResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('billingDate' in value) || value['billingDate'] === undefined) return false;
    if (!('invoiceDate' in value) || value['invoiceDate'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('vaultId' in value) || value['vaultId'] === undefined) return false;
    if (!('userVaultType' in value) || value['userVaultType'] === undefined) return false;
    if (!('userName' in value) || value['userName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('contactInfo' in value) || value['contactInfo'] === undefined) return false;
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    if (!('studentName' in value) || value['studentName'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('locationName' in value) || value['locationName'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('failureReason' in value) || value['failureReason'] === undefined) return false;
    if (!('emailed' in value) || value['emailed'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('releasedAt' in value) || value['releasedAt'] === undefined) return false;
    if (!('processedAt' in value) || value['processedAt'] === undefined) return false;
    if (!('emailedAt' in value) || value['emailedAt'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    return true;
}

export function InvoiceResponseFromJSON(json: any): InvoiceResponse {
    return InvoiceResponseFromJSONTyped(json, false);
}

export function InvoiceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['id']),
        'tenantId': ApiUserTasksGetPageParameterFromJSON(json['tenantId']),
        'billingDate': (new Date(json['billingDate'])),
        'invoiceDate': (new Date(json['invoiceDate'])),
        'userId': ApiUserTasksGetPageParameterFromJSON(json['userId']),
        'vaultId': ActorActivityRecordActorUserIdFromJSON(json['vaultId']),
        'userVaultType': json['userVaultType'],
        'userName': json['userName'],
        'email': json['email'],
        'address': InvoiceAddressSnapshotFromJSON(json['address']),
        'contactInfo': InvoiceContactInfoSnapshotFromJSON(json['contactInfo']),
        'studentId': ApiUserTasksGetPageParameterFromJSON(json['studentId']),
        'studentName': json['studentName'],
        'currency': json['currency'],
        'locationId': ActorActivityRecordActorUserIdFromJSON(json['locationId']),
        'locationName': json['locationName'],
        'totalAmount': json['totalAmount'],
        'status': InvoiceStatusFromJSON(json['status']),
        'failureReason': json['failureReason'],
        'emailed': json['emailed'],
        'createdAt': (new Date(json['createdAt'])),
        'releasedAt': (json['releasedAt'] == null ? null : new Date(json['releasedAt'])),
        'processedAt': (json['processedAt'] == null ? null : new Date(json['processedAt'])),
        'emailedAt': (json['emailedAt'] == null ? null : new Date(json['emailedAt'])),
        'details': ((json['details'] as Array<any>).map(InvoiceDetailSnapshotFromJSON)),
    };
}

export function InvoiceResponseToJSON(json: any): InvoiceResponse {
    return InvoiceResponseToJSONTyped(json, false);
}

export function InvoiceResponseToJSONTyped(value?: InvoiceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterToJSON(value['id']),
        'tenantId': ApiUserTasksGetPageParameterToJSON(value['tenantId']),
        'billingDate': value['billingDate'].toISOString().substring(0,10),
        'invoiceDate': value['invoiceDate'].toISOString().substring(0,10),
        'userId': ApiUserTasksGetPageParameterToJSON(value['userId']),
        'vaultId': ActorActivityRecordActorUserIdToJSON(value['vaultId']),
        'userVaultType': value['userVaultType'],
        'userName': value['userName'],
        'email': value['email'],
        'address': InvoiceAddressSnapshotToJSON(value['address']),
        'contactInfo': InvoiceContactInfoSnapshotToJSON(value['contactInfo']),
        'studentId': ApiUserTasksGetPageParameterToJSON(value['studentId']),
        'studentName': value['studentName'],
        'currency': value['currency'],
        'locationId': ActorActivityRecordActorUserIdToJSON(value['locationId']),
        'locationName': value['locationName'],
        'totalAmount': value['totalAmount'],
        'status': InvoiceStatusToJSON(value['status']),
        'failureReason': value['failureReason'],
        'emailed': value['emailed'],
        'createdAt': value['createdAt'].toISOString(),
        'releasedAt': value['releasedAt'] == null ? value['releasedAt'] : value['releasedAt'].toISOString(),
        'processedAt': value['processedAt'] == null ? value['processedAt'] : value['processedAt'].toISOString(),
        'emailedAt': value['emailedAt'] == null ? value['emailedAt'] : value['emailedAt'].toISOString(),
        'details': ((value['details'] as Array<any>).map(InvoiceDetailSnapshotToJSON)),
    };
}

